export const teamColorClasses = [
  "text-bg-success",
  "text-bg-warning",
  "text-bg-secondary",
  "text-bg-primary",
  "text-bg-danger",
];
